export default function forms() {
	[].forEach.call(document.querySelectorAll(".form-input"), function (elem) {
		elem.setAttribute("data-bad-input", "Required");
		elem.setAttribute("data-custom-error", "Required");
		elem.setAttribute("data-pattern-mismatch", "Required");
		elem.setAttribute("data-range-overflow", "Required");
		elem.setAttribute("data-range-underflow", "Required");
		elem.setAttribute("data-step-mismatch", "Required");
		elem.setAttribute("data-too-long", "Required");
		elem.setAttribute("data-too-short", "Required");
		elem.setAttribute("data-type-mismatch", "Required");
		elem.setAttribute("data-value-missing", "Required");
	});

	hyperform.addTranslation("en", {
		TextTooLong: "Required",
		ValueMissing: "Required"
	});

	hyperform.setLanguage("en");

	/* change Hyperform's renderer to write into the global error div */
	hyperform.setRenderer('attachWarning', function(warning, element) {
		/*if (element.labels && element.labels.length) {
			warning.insertAdjacentText('afterbegin', element.labels[0].textContent);
		}*/
		element.parentNode.appendChild(warning);
	});


	window.onlyNumbers = function(e) {
	    if (e && e.keyCode) {
	    	if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105 || e.keyCode === 8 || e.keyCode === 9 || e.keyCode === 46)) {
	    		// numbers, then do nothing
	        } else {
	        	console.log("preventDefault")
	        	e.preventDefault();
	        	return false;
	        }
	    } else {
	    	console.log("preventDefault")
	    	e.preventDefault();
	    	return false;
	    }
	};

	window.checkNumbers = function (input) {
		var resultValue = input.value.replace(/~`´¨/, '')
		console.log(resultValue)
	}

	hyperform(window, {
		preventImplicitSubmit: true,
		revalidate: 'hybrid'
	});


	hyperform.addTranslation("en",{
		TextTooLong:"Too much content",
		TextTooShort:"Required",
		ValueMissing:"Required",
		CheckboxMissing:"Required",
		RadioMissing:"Required",
		FileMissing:"Required",
		SelectMissing:"Required",
		InvalidEmail:"Wrong format",
		InvalidURL:"Wrong format",
		InvalidDate:"Wrong format",
		PatternMismatch:"Wrong format",
		PatternMismatchWithTitle:"Wrong format",
		NumberRangeOverflow:"Wrong format",
		DateRangeOverflow:"Wrong format",
		TimeRangeOverflow:"Wrong format",
		NumberRangeUnderflow:"Wrong format",
		DateRangeUnderflow:"Wrong format",
		TimeRangeUnderflow:"Wrong format",
		StepMismatch:"Wrong format",
		StepMismatchOneValue:"Wrong format",
		BadInputNumber:"Wrong format",
		"Please match the requested type.": "Wrong format",
		"Please comply with all requirements.": "Wrong format",
		"Please lengthen this text to %l characters or more (you are currently using %l characters).": "Wrong format",
		"Please use the appropriate format.": "Wrong format",
		"Please enter a comma separated list of email addresses.": "Wrong format",
		"Please select a file of the correct type.": "Wrong format",
		"Please select one or more files.": "Wrong format",
		"any value":"Required",
		"any valid value":"Wrong format",
	});
	hyperform.setLanguage("en");
}


//////////////////
// WEBPACK FOOTER
// ./src/js/components/forms.js
// module id = 7
// module chunks = 0